import { render, staticRenderFns } from "./ConceptsTree.vue?vue&type=template&id=602b30ac&scoped=true"
import script from "./ConceptsTree.vue?vue&type=script&lang=js"
export * from "./ConceptsTree.vue?vue&type=script&lang=js"
import style0 from "./ConceptsTree.vue?vue&type=style&index=0&id=602b30ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602b30ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/.pnpm/vuetify-loader@1.7.3_uhb5aaqqgawn4pxsnzso5z623i/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VTreeview})
